export const SESSION_REQUEST = 'PUBLIC_SESSION_REQUEST';
export const SESSION_SUCCESS = 'PUBLIC_SESSION_SUCCESS';
export const SESSION_FAILURE = 'PUBLIC_SESSION_FAILURE';

// actions for sim graph data
export const SESSION_SIMULATOR_STATS_REQUEST = 'PUBLIC_SESSION_SESSION_SIMULATOR_STATS_REQUEST';
export const SESSION_SIMULATOR_STATS_SUCCESS = 'PUBLIC_SESSION_SESSION_SIMULATOR_STATS_SUCCESS';

export const SPRITES_ACCESS_REQUEST = 'PUBLIC_SESSION_SPRITES_ACCESS_REQUEST';
export const SPRITES_ACCESS_SUCCESS = 'PUBLIC_SESSION_SPRITES_ACCESS_SUCCESS';

export const DISPOSE_SESSION_DETAIL_STORE = 'PUBLIC_DISPOSE_SESSION_DETAIL_STORE';
export const SESSION_SWITCH = 'PUBLIC_SESSION_SESSION_SWITCH';

export const REORDER_STREAMS = 'REORDER_STREAMS';
